module.exports = __webpack_public_path__ + "img/Configure-background-green.7af5b67e.svg";